import { render } from "./LatestActivities.vue?vue&type=template&id=8fa3e990"
import script from "./LatestActivities.vue?vue&type=script&lang=js"
export * from "./LatestActivities.vue?vue&type=script&lang=js"

import exportComponent from "C:\\wamp\\www\\GuideParis\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__